import React from "react";
import { useNavigate } from "react-router-dom";

export default function GameSelector() {
  const navigate = useNavigate();

  const handleSelect = (game) => {
    navigate(`/${game}`);
  };

  return (
    <div style={styles.wrapper}>
      <button onClick={() => handleSelect("spyfall")} style={styles.button}>
        🕵️ Spyfall
      </button>
      <button onClick={() => handleSelect("promptquestions")} style={styles.button}>
        ❓ Prompt questions
      </button>
      <button onClick={() => handleSelect("crossword")} style={styles.button}>
        🧩 Crossword
      </button>
      <button onClick={() => handleSelect("mafia")} style={{ ...styles.button, opacity: 0.5 }} disabled>
        🎭 Mafia (soon)
      </button>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
  },
  button: {
    padding: "1rem 2rem",
    fontSize: "1.2rem",
    borderRadius: "12px",
    border: "none",
    cursor: "pointer",
    backgroundColor: "#4e6cff",
    color: "white",
    transition: "0.3s",
  },
};
